export const galleryImgCount = 80;
